import { documentUrl } from "@/lib/images";
import { useRef, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Upload, FileText, X, Loader2, Eye } from "lucide-react";

// Object storage'a belge yükler (/uploads/document), URL + dosya adını döndürür.
export default function DocUpload({ value, filename, onChange, label, testid, required, accept = ".pdf,.png,.jpg,.jpeg,.webp,.doc,.docx" }) {
  const inp = useRef(null);
  const [busy, setBusy] = useState(false);
  const viewUrl = documentUrl(value);

  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/uploads/document", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url, data.filename);
      toast.success("Belge yüklendi");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Yükleme başarısız");
    } finally {
      setBusy(false);
      if (inp.current) inp.current.value = "";
    }
  };

  return (
    <div data-testid={testid}>
      {label && <label className="text-sm font-medium text-slate-700">{label}{required && <span className="text-red-500"> *</span>}</label>}
      <input ref={inp} type="file" accept={accept} className="hidden" data-testid={`${testid}-input`} onChange={pick} />
      {value ? (
        <div className="mt-1 flex items-center gap-2 rounded-md bg-emerald-50 px-2.5 py-2 ring-1 ring-inset ring-emerald-200" data-testid={`${testid}-uploaded`}>
          <FileText className="h-4 w-4 shrink-0 text-emerald-600" />
          <span className="min-w-0 flex-1 truncate text-xs text-emerald-800">{filename || "Belge"}</span>
          <a href={viewUrl} target="_blank" rel="noreferrer" className="text-emerald-700 hover:text-emerald-900" title="Görüntüle" data-testid={`${testid}-view`}><Eye className="h-4 w-4" /></a>
          <button type="button" data-testid={`${testid}-remove`} onClick={() => onChange("", "")} className="text-red-500 hover:text-red-700" title="Kaldır"><X className="h-4 w-4" /></button>
        </div>
      ) : (
        <button type="button" data-testid={`${testid}-btn`} disabled={busy} onClick={() => inp.current?.click()}
          className="mt-1 flex w-full items-center justify-center gap-2 rounded-md border border-dashed border-slate-300 bg-white px-3 py-2 text-xs font-medium text-slate-500 transition-colors hover:border-brand-green hover:text-brand-green disabled:opacity-50">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} {busy ? "Yükleniyor..." : "Dosya Yükle (pdf/png/jpg/word)"}
        </button>
      )}
    </div>
  );
}
